<template>
  <div class="estimate">
    <div class="title">学科评估</div>
    <div class="box2">
      <div class="left">
        <el-row class="tac">
          <el-col :span="12">
            <el-menu default-active="1" class="el-menu-vertical-demo" background-color="#ffffff" text-color="#000" active-text-color="#70cba9">
              <el-menu-item index="0">
                <h4>门类</h4>
              </el-menu-item>
              <el-menu-item v-for="list in cateList" :key="list.id" :index="list.id.toString()" @click="sendId">
                <span slot="title">{{list.categoryName}}</span>
              </el-menu-item>
            </el-menu>
          </el-col>
          <el-col :span="12">
            <el-menu default-active="哲学" class="el-menu-vertical-demo" background-color="#ffffff" text-color="#000" active-text-color="#70cba9">
              <el-menu-item index="0">
                <h4>专业</h4>
              </el-menu-item>
              <el-menu-item v-for="list in majorList" :key="list.majorCode" :index="list.majorName" @click="sendName">
                <span slot="title">{{list.majorName}}</span>
              </el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </div>
      <div class="right">
        <p>{{this.name}}</p>
        <template>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column type="index" label="序号" width="100" align="center">
            </el-table-column>
            <el-table-column prop="code" label="学校代码" align="center">
            </el-table-column>
            <el-table-column prop="schoolName" label="学校名称" align="center">
            </el-table-column>
            <el-table-column prop="level" label="评估结果" align="center">
            </el-table-column>
            <el-table-column prop="ranking" label="位次百分比" align="center">
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import category from '../../api/configuration'
export default {
  data() {
    return {
      cateList: [],
      majorList: [],
      id: 1,
      name: '哲学',
      tableData: []
    }
  },
  methods: {
    getCategories() {
      category.getCategories().then(res => {
        this.cateList = res.list
      })
    },
    getMajorById(id) {
      category.getMajorById(id).then(res => {
        this.majorList = res.list
        this.name = this.majorList[0].majorName
        this.getEstimateResultByName(this.name)
      })
    },
    getEstimateResultByName(name) {
      category.getEstimateResultByName(name).then(res => {
        this.tableData = res.list
      })
    },
    sendId(e) {
      this.id = e.index
      this.getMajorById(this.id)
    },
    sendName(e) {
      this.name = e.index
      this.getEstimateResultByName(this.name)
    }
  },
  created() {
    this.getCategories()
    this.getMajorById(this.id)
    this.getEstimateResultByName(this.name)
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-size: 16px;
}
.estimate {
  height: 100vh;
  overflow: auto;
}
.box2 {
  width: 80%;
  margin: 0 auto;
}
.dalfbut {
  width: 200px;
  height: 40px;
  border-radius: 4px;
  background-color: #66b1ff;
  color: #fff;
  margin: 20px 0;
  margin-right: 20px;
  background-color: #fff;
  color: #000;
  border: 1px solid #1db278;
}
.dalfbut:hover {
  color: #fff;
  background-color: #1db278;
}

a {
  color: #606266;
}

a:hover {
  color: #1cb278;
  text-decoration: underline;
}

.box2 .left {
  width: 30%;
  float: left;
}
.box2 .right {
  float: right;
  width: 70%;
}
.box2 .right p {
  text-align: center;
  line-height: 56px;
  font-weight: 700;
}
.title {
  width: 100%;
  height: 80px;
  background-image: url(../../assets/img/school-estimate.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 -80px;
  text-align: center;
  line-height: 80px;
  font-size: 32px;
  color: #fff;
  letter-spacing: 20px;
  opacity: 0.8;
}
</style>

